import Particles, { initParticlesEngine } from "@tsparticles/react";
import { useEffect, useMemo, useState } from "react";
import { loadSlim } from "@tsparticles/slim";

const Particules = (props) => {
  const [engineLoaded, setEngineLoaded] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
      setEngineLoaded(true);
    });
  }, []);

  const options = useMemo(() => ({
    fullScreen: {
      enable: false
    },
    background: {
      color: {
        value: "transparent"
      }
    },
    fpsLimit: 120,
    interactivity: {
      events: {
        onClick: {
          enable: true,
          mode: "repulse"
        },
        onHover: {
          enable: true,
          mode: "grab"
        }
      },
      modes: {
        push: {
          distance: 200,
          duration: 15
        },
        grab: {
          distance: 150
        }
      }
    },
    particles: {
      color: {
        value: "#FFFFFF"
      },
      links: {
        color: "#FFFFFF",
        distance: 150,
        enable: true,
        opacity: 0.3,
        width: 1
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce"
        },
        random: true,
        speed: 1,
        straight: false
      },
      number: {
        density: {
          enable: true,
          area: 800 // Surface de référence
        },
        value: 150
      },
      opacity: {
        value: 1.0
      },
      shape: {
        type: "circle"
      },
      size: {
        value: { min: 1, max: 3 }
      }
    },
    detectRetina: true
  }), []);

  if (!engineLoaded) return null;

  return (
    <div className="absolute inset-0 w-full h-full z-0">
      <Particles
        id={props.id}
        options={options}
        className="w-full h-full"
      />
    </div>
  );
};

export default Particules;